import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import AssignmentChart from '../../../../components/AssignmentChart';

class AssignmentsStats extends Component {
  render() {
    const { assignmentStore } = this.props.store;
    const { date, assignmentShipmentStats } = assignmentStore;

    return <AssignmentChart date={date} stats={assignmentShipmentStats} onCollapse={this.props.onCollapse} />;
  }
}

const AssignmentsStatsCompose = compose(inject('store'), observer)(AssignmentsStats);

export default AssignmentsStatsCompose;
